import { DateTime } from "luxon";
import { IUrlVariables } from "../intefaces/IUrlVariables";
import { IHelper } from "./IHelper";

export class Helper implements IHelper {
    UrlSpliting(url: string): IUrlVariables {
        return this.urlSpliting(url);
    }

    ShowAllTitles(title: string[]) {
        return this.showAllTitles(title);
    }

    FormatDate(date: string) {
        return this.formatDate(date);
    }

    private urlSpliting(url: string): IUrlVariables {
        let getSearch = url.split('&');
        let urlVariables: IUrlVariables = {};

        // eslint-disable-next-line
        getSearch.map((element: string) => {
            if (element.startsWith('?q=')) {
                let st = element.split('?q=').pop();
                urlVariables.searchQuery = st !== undefined ? st.replace(/%20/g, " ").replace(/%27/g, "'") : '';
            }
            if (element.startsWith('fuzzy')) {
                let st = element.split('fuzzy=').pop();
                urlVariables.fuzzy = st !== undefined ? st : 'true';
            }
            if (element.startsWith('id')) {
                let st = element.split('id=').pop();
                urlVariables.id = st !== undefined ? st.replace(/%20/g, " ").replace(/%27/g, "'") : '';
            }

        });

        return urlVariables;
    }

    private showAllTitles(title: string[]) {
        let _title: string = '';


        if (title.length > 0) {
            title.map((t, i) => {
                if (i > 0) {
                    _title += `, `;
                }
                _title += `${t}`;
            });
        } else {
            _title = 'Title unknown';
        }

        return _title;
    }

    private formatDate(date: string) {
        if (date == null) {
            return 'Date unknown';
        }
        
        let _date = DateTime.fromISO(date);
        return _date.toFormat('dd LLLL yyyy');
    }

}
